import React, { useState, useEffect } from 'react';
import { FaQuoteLeft, FaQuoteRight, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './Testimonials.css';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      id: 1,
      name: 'Selvaraj',
      text: 'Good service. Clean car. Driver was nice.',
      rating: 5
    },
    {
      id: 2,
      name: 'Kumari',
      text: 'Low price. Came on time. Very good.',
      rating: 5
    },
    {
      id: 3,
      name: 'Raman',
      text: 'Came to Chennai. Car was good. Driver was nice.',
      rating: 5
    },
    {
      id: 4,
      name: 'Lakshmi',
      text: 'Journey was good. Car was clean. Price was low.',
      rating: 5
    },
    {
      id: 5,
      name: 'Murugan',
      text: 'Good service. Will use again. Thank you.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === testimonials.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToTestimonial = (index) => {
    setCurrentIndex(index);
  };

  // Auto-scroll every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextTestimonial, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div id="testimonials-section" className="testimonials-section">
      <div className="testimonials-container">
        <h2 className="testimonials-title">Customer Reviews</h2>
        
        <div className="testimonials-carousel">
          <button 
            className="carousel-btn prev-btn"
            onClick={prevTestimonial}
            aria-label="Previous testimonial"
          >
            <FaChevronLeft />
          </button>

          <div className="testimonial-card">
            <div className="quote-left">
              <FaQuoteLeft />
            </div>
            
            <div className="testimonial-content">
              <div className="customer-info">
                <div className="customer-avatar">
                  <div className="avatar-placeholder">
                    <span>{testimonials[currentIndex].name.charAt(0)}</span>
                  </div>
                </div>
                <div className="customer-name">
                  {testimonials[currentIndex].name}
                </div>
              </div>
              
              <div className="testimonial-text">
                {testimonials[currentIndex].text}
              </div>
              
              <div className="testimonial-rating">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <span key={i} className="star">★</span>
                ))}
              </div>
            </div>
            
            <div className="quote-right">
              <FaQuoteRight />
            </div>
          </div>

          <button 
            className="carousel-btn next-btn"
            onClick={nextTestimonial}
            aria-label="Next testimonial"
          >
            <FaChevronRight />
          </button>
        </div>

        <div className="testimonials-pagination">
          {testimonials.map((_, index) => (
            <button
              key={index}
              className={`pagination-dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => goToTestimonial(index)}
              aria-label={`Go to testimonial ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
